// Global Application & Copyright Constants
export const APP_CONFIG = {
  appName: 'Filter Hotels',
  companyName: 'FilterHotels',
  legalEntity: 'FilterHotels',
  currentYear: 2026,
  get copyrightText() {
    return `© ${this.currentYear} ${this.companyName}`;
  },
  get copyrightFullText() {
    return `© ${this.currentYear} ${this.companyName}. All rights reserved.`;
  },
  contactEmail: 'filterhotels@gmail.com',
  contactPhone: '+91 7020886313',
  logoPath: '/FilterHotelsLogo.png',
};

export default APP_CONFIG;
